import React, { useEffect, useState,useContext } from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import Camera from "./Camera";
import { TracingEventContext } from "../../../../contexts";
import styles from "./WareHouse.module.css";
import axiosClient from "../../../../services/axiosClient";
const cx = classNames.bind(styles);
const WareHouse = ({ icon, name, show, parentShow, onClick, indexWareHouse, code, status, groupCode }) => {
  const {
    cameraCode,
    setCameraCode,
    setName,
    listCodeCamera,
    setListCodeCamera,
    isApply, setIsApply
  } = useContext(TracingEventContext);
  const [camera, setCamera] = useState([]);
  const [check, setCheck] = useState(false);
  const [size, setSize] = useState(1)
  const [pageEnd, setPageEnd] = useState(false)
  const [isChange,setIsChange] = useState(false)
  const checkStatus = (status) => {
    if (status === 'On' || status === 'Off') {
      return true
    } else {
      return false
    }
  }

  useEffect(() => {
    const getListCameraByCode = async () => {
      if (!pageEnd) {
        const res = await axiosClient.get(`cameraManagement/get-list-camera/?page=1&size=1000&warehouse_code=${code}`, {
          params: {
            camera_status: checkStatus(status) ? status : null,
            group_code: groupCode ? groupCode : null,
            ai_already: !checkStatus(status) ? status  : 0,
          }
        })
        if (res.data.length > 0) {
          setCamera(prev => [...prev, ...res.data])
        } else {
          setPageEnd(true)
        }
      }
    }
    getListCameraByCode()
  }, [code, name, status, groupCode])
  const handleChangeStatusW = (e) => {
    setCheck(e)
    setIsChange(true)
    const data= camera.map((item)=>{
     return {
      code:item.CAMERA.CODE,
      name:item.CAMERA.NAME_CAM,
     }
    })

    if(e){
      let arr = camera.map(it=>{
        return {
          code:it.CAMERA?.CODE,
          name:it.CAMERA?.NAME_CAM
        }
      })
      listCodeCamera.forEach(item => {
        const filter = arr.filter(it=>it.code !== item.code)
        arr=filter
      });
      setListCodeCamera([...listCodeCamera,...arr])
    }
    else{
      let arr = listCodeCamera
      camera.forEach(item => {
        const filter = arr.filter(it=>it.code !== item.CAMERA.CODE)
        arr=filter
      });
      setListCodeCamera(arr)
    }
    setIsApply(true)
  }

  const onClicks = (data) => {
    onClick(data);
    // handleChangeStatusW(!check)
  };

  const handleScrollBar = (e) => {
    if (e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.target.clientHeight && !pageEnd) {
      setSize(size + 1)
    }
  }
  return (
    <div className={cx("item")}>
      <div onClick={(e) => onClicks(indexWareHouse)} className={cx("location")}>
        <span className={cx("icon")}>{icon}</span>
        <span className={cx("name")}>{name}</span>
       
      </div>
      <input checked={check} type="checkbox" className={cx("check")} onChange={e => handleChangeStatusW(e.target.checked)}/>
      {
        parentShow && show && (
          <div className={cx("warehouse")} onScroll={handleScrollBar}>
            {camera &&
              camera.map((item, index) => (
                <Camera
                  check={check}
                  key={index}
                  status={item.CAMERA?.STATUS}
                  name={item.CAMERA?.NAME_CAM}
                  camID={item.CAMERA?.CODE}
                  setCheck={setCheck}
                  prioritized={item.CAMERA.PRIORITIZED}
                  isChange={isChange}
                />
              ))}
          </div>
        )
      }
    </div >
  );
};
WareHouse.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  show: PropTypes.bool.isRequired,
  parentShow: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  index: PropTypes.number,
};
export default WareHouse;
